import { jsx as _jsx } from "react/jsx-runtime";
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useMemo } from 'react';
import ContentfulLink from '../../../common/Link/ContentfulLink';
export const useFaqRenderOptions = () => {
    return useMemo(() => ({
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri: url } = node.data;
                return _jsx(ContentfulLink, { url: url, children: children });
            },
            [BLOCKS.HEADING_2]: (_node, children) => (_jsx(Typography.Title, { level: 2, elementTheme: "subtitle2", bold: true, children: children })),
            [BLOCKS.HEADING_3]: (_node, children) => (_jsx(Typography.Title, { level: 3, elementTheme: "subtitle2", bold: true, children: children })),
            [BLOCKS.HEADING_4]: (_node, children) => (_jsx(Typography.Title, { level: 4, elementTheme: "subtitle2", bold: true, children: children })),
            [BLOCKS.HEADING_5]: (_node, children) => (_jsx(Typography.Title, { level: 5, elementTheme: "subtitle2", bold: true, children: children })),
            [BLOCKS.HEADING_6]: (_node, children) => (_jsx(Typography.Title, { level: 6, elementTheme: "subtitle2", bold: true, children: children })),
            [BLOCKS.PARAGRAPH]: (_node, children) => (_jsx(Typography, { elementTheme: "body2", children: children })),
            [BLOCKS.LIST_ITEM]: (_node, children) => (_jsx("li", { style: { marginBlock: 0 }, children: children })),
            [BLOCKS.OL_LIST]: (_node, children) => (_jsx("ol", { style: { marginBlock: 0 }, children: children })),
            [BLOCKS.UL_LIST]: (_node, children) => (_jsx("ul", { style: { marginBlock: 0 }, children: children })),
        },
    }), []);
};
